import { Component } from '@angular/core';
import { VisitsService } from '../../../shared/services/visits.service';
import { AppSessionService } from '../../../../../core/app-session-service/app-session.service';

@Component({
  selector: 'app-visits-modal-continue',
  templateUrl: './visits-modal-continue.component.html',
  styleUrls: ['./visits-modal-continue.component.scss'],
})
export class VisitsModalContinueComponent {
  constructor(public visitsService: VisitsService, private sessionService: AppSessionService) {}

  public async continueDraftedVisit() {
    if (this.sessionService.sessionGlobal?.visitId) {
      await this.visitsService.reopenVisit(+this.sessionService.sessionGlobal?.visitId);
      this.sessionService.sendResponseToIframe(
        false,
        null,
        '',
        this.sessionService.sessionModal?.lastIframeId,
        NaN,
        true,
      );
    } else {
      throw new Error('[VISIT APP] Session global aint initialized.');
    }
  }
}
